import '../../App.css';
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from "../../components/Layout"

const RegularGame = () => {
  const navigate = useNavigate();
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [currentQuestionAnswer, setCurrentQuestionAnswer] = useState("");
  const [numPoints, setNumPoints] = useState(0);
  const [timer, setTimer] = useState(60);
  const [isActive, setIsActive] = useState(false);
  const workerRef = useRef<Worker | null>(null); 
  const answerInputRef = useRef<HTMLInputElement>(null);
  const { gamemode } = useParams();

  const handleTimerUpdate = (time) => {
    console.log(time);
    setTimer(60 - time); // Update the timer state based on elapsed time
    if (time >= 60) {
      // Handle game over logic here
      navigate("/GameOver", { state: { numPoints } });
    }
  };

  // Start the timer when the component mounts or when the game starts
  useEffect(() => {
    return () => {
      if (workerRef.current) {
        workerRef.current.terminate(); // Terminate the worker
      }
    };
  }, []);

  function genDigit(lowerBoundInclusive, upperBoundInclusive) {
    return Math.floor(Math.random() * upperBoundInclusive - (lowerBoundInclusive - 1)) + lowerBoundInclusive;
  }

  function genAddition() {
    let firstDigit = genDigit(1, 9)
    let secondDigit = genDigit(0, 9)
    let question = firstDigit.toString() + " + " + secondDigit.toString() + " = ?"
    let answer = (firstDigit + secondDigit).toString()
    setCurrentQuestion(question);
    setCurrentQuestionAnswer(answer)
  }

  function genSubtraction() {
    let firstDigit = genDigit(0, 19)
    let secondDigit = genDigit(0, 9)
    let question = firstDigit.toString() + " - " + secondDigit.toString() + " = ?"
    let answer = (firstDigit - secondDigit).toString()
    setCurrentQuestion(question);
    setCurrentQuestionAnswer(answer)
  }

  function genMultiplication() {
    let firstDigit = genDigit(1, 9)
    let secondDigit = genDigit(0, 9)
    let question = firstDigit.toString() + " x " + secondDigit.toString() + " = ?"
    let answer = (firstDigit * secondDigit).toString()
    setCurrentQuestion(question);
    setCurrentQuestionAnswer(answer)
  }

  function genDivision() {
    let firstDigit = genDigit(1, 9)
    let secondDigit = genDigit(0, 9)
    let question = firstDigit.toString() + " / " + secondDigit.toString() + " = ?"
    let answer = (firstDigit / secondDigit).toString()
    setCurrentQuestion(question);
    setCurrentQuestionAnswer(answer)
  }

  function genQuestion() {
    switch(gamemode) {
      case 'addition':
        genAddition()
        break;
      case 'subtraction':
        genSubtraction()
        break;
      case 'multiplication':
        genMultiplication()
        break;
      case 'division':
        genDivision()
        break;
      default:
        let question = "Error";
        let answer = "Error"
        setCurrentQuestion(question);
        setCurrentQuestionAnswer(answer)
    }
  }

  function handleStartGame() {
    setIsActive(true)
    genQuestion()

    // Initialize the Web Worker if it doesn't already exist
    if (!workerRef.current) {
      workerRef.current = new Worker(new URL('../timerWorker.js', import.meta.url));

      // Listen for messages from the worker
      workerRef.current.onmessage = (event) => {
        handleTimerUpdate(event.data); // Update the timer state
      };
    }
  }

  function submitForm(event) {
    event.preventDefault(); // Prevent the form from submitting
    if (answerInputRef.current) { 
      const submittedAnswer = answerInputRef.current.value
      console.log(submittedAnswer)
      if (isActive) {
          if (submittedAnswer == currentQuestionAnswer) {
          console.log("correct")
          setNumPoints(numPoints + 1)
          } else {
          console.log("wrong")
          }
          answerInputRef.current.value = '';
          genQuestion()
      }
    }
  }
 
  return (
    <Layout>
      <h1 className="section-title">Banana Run</h1>

      <div className="panel game-panel anim-pop">
        <div className="stat-row">
          <span className="stat">
            Mode <span className="stat-value">{gamemode}</span>
          </span>
          <span className="stat stat-points">
            🍌 Bananas <span className="stat-value">{numPoints}</span>
          </span>
          {isActive && (
            <span className={timer <= 10 ? "stat stat-timer is-low" : "stat stat-timer"}>
              ⏱ Time <span className="stat-value">{timer}s</span>
            </span>
          )}
        </div>

        {isActive ? (
          <>
            <div className="question-bubble">{currentQuestion}</div>
            <form className="answer-form" onSubmit={submitForm}>
              <input
                className="input"
                ref={answerInputRef}
                type="text"
                name="answer"
                placeholder="Your answer"
                autoComplete="off"
                autoFocus
              />
              <input className="btn" type="submit" value="Submit" />
            </form>
            <p className="hint">Press Enter to send it and grab the next question.</p>
          </>
        ) : (
          <>
            <div className="question-bubble is-waiting">
              Ready to swing? You get 60 seconds to collect as many bananas as you can.
            </div>
            <button className="btn btn-xl" onClick={handleStartGame}>Start Climbing</button>
          </>
        )}
      </div>
    </Layout>
  );
}

export default RegularGame;
